export const UPDATE_PLAYLIST_REQUEST = "UPDATE_PLAYLIST_REQUEST";
export const UPDATE_PLAYLIST_SUCCESS = "UPDATE_PLAYLIST_SUCCESS";
export const UPDATE_PLAYLIST_ERROR = "UPDATE_PLAYLIST_ERROR";
export const UPDATE_PLAYLIST_DONE = "UPDATE_PLAYLIST_DONE";

export const updatePlaylistRequest = (payload) => ({
  type: UPDATE_PLAYLIST_REQUEST,
  ...payload,
});

export const updatePlaylistSuccess = (playlist) => ({
  type: UPDATE_PLAYLIST_SUCCESS,
  playlist,
});

export const updatePlaylistError = () => ({
  type: UPDATE_PLAYLIST_ERROR,
});

export const updatePlaylistDone = () => ({
  type: UPDATE_PLAYLIST_DONE,
});



// WEBPACK FOOTER //
// ./src/pages/playlists/update/actions.js